import { render, staticRenderFns } from "./metarget.vue?vue&type=template&id=c4059d76&scoped=true"
import script from "./metarget.vue?vue&type=script&lang=js"
export * from "./metarget.vue?vue&type=script&lang=js"
import style0 from "./metarget.vue?vue&type=style&index=0&id=c4059d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4059d76",
  null
  
)

export default component.exports